import { ApiService } from "../ApiService";
import {
    ProductPromotion,
    AddProductPromotionPayload,
    UpdateProductPromotionPayload,
    DeleteProductPromotionParams,
    GetProductPromotionByIdParams,
    GetAllProductPromotionsParams,
} from "Types/Admin/AdminProductPromotionType";
import { ResultsDTO } from "Types/ResultsDTO";

export const ProductPromotionApiSlice = ApiService.enhanceEndpoints({
    addTagTypes: ["ProductPromotion", "AdminProducts"],
}).injectEndpoints({
    endpoints: (builder) => ({
        addProductPromotion: builder.mutation<ResultsDTO<ProductPromotion>, AddProductPromotionPayload>({
            query: (payload) => ({
                url: "/ProductPromotion/addProductPromotion",
                method: "POST",
                body: payload,
                params: { plant: payload.promotionHdr.plant },
            }),
            invalidatesTags: ["ProductPromotion", { type: "AdminProducts", id: "LIST" }],
        }),

        updateProductPromotion: builder.mutation<ResultsDTO<ProductPromotion>, UpdateProductPromotionPayload>({
            query: (payload) => ({
                url: "/ProductPromotion/updateProductPromotion",
                method: "PUT",
                body: payload,
                params: { plant: payload.promotionHdr.plant },
            }),
            invalidatesTags: ["ProductPromotion", { type: "AdminProducts", id: "LIST" }],
        }),

        deleteProductPromotion: builder.mutation<ResultsDTO, DeleteProductPromotionParams>({
            query: ({ id, plant }) => ({
                url: "/ProductPromotion/deleteProductPromotion",
                method: "DELETE",
                params: { id, plant },
            }),
            invalidatesTags: ["ProductPromotion", { type: "AdminProducts", id: "LIST" }],
        }),

        getProductPromotionById: builder.query<ResultsDTO<ProductPromotion>, GetProductPromotionByIdParams>({
            query: ({ id, plant }) => ({
                url: "/ProductPromotion/getProductPromotionById",
                method: "GET",
                params: { id, plant },
            }),
            providesTags: ["ProductPromotion"],
        }),

        getAllProductPromotions: builder.query<ProductPromotion[], GetAllProductPromotionsParams>({
            query: ({ plant, search }) => ({
                url: "/ProductPromotion/getAllProductPromotions",
                method: "GET",
                params: { plant, search },
            }),
            transformResponse: (res: ResultsDTO<ProductPromotion[]>) => res.results ?? [],
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ promotionHdr: { id } }) => ({
                            type: "ProductPromotion" as const,
                            id,
                        })),
                        { type: "ProductPromotion", id: "LIST" },
                    ]
                    : [{ type: "ProductPromotion", id: "LIST" }],
        }),
    }),
});

export const {
    useAddProductPromotionMutation,
    useUpdateProductPromotionMutation,
    useDeleteProductPromotionMutation,
    useGetProductPromotionByIdQuery,
    useGetAllProductPromotionsQuery,
    useLazyGetProductPromotionByIdQuery,
    useLazyGetAllProductPromotionsQuery,
} = ProductPromotionApiSlice;
